export default "__VITE_ASSET__54e88d3f__"